import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

/**
 * Reworked-tier Toggle, behind `release-experimental-design-system-forms`
 * (`useIsExperimentalDesignSystemForms`). Same variant keys/colours/states as
 * the stable recipe, but sizes realign to the experimental Button scale (`sm`→
 * button `sm`, `default`→`md`, `lg`→`lg`) so a toggle sits flush beside a button
 * of the matching name. Rounding and icon↔text `gap` move onto each size (the
 * stable base has a shared `rounded-md` and no gap) so both track the button per
 * size — see the `size` variant.
 */
export const toggleVariantsExperimental = cva(
  cn(
    'inline-flex items-center justify-center text-sm font-medium transition-colors hover:bg-background-secondary hover:text-text-primary disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-background-secondary data-[state=on]:text-text-primary',
    focusRing
  ),
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        outline:
          'border border-border bg-transparent hover:bg-background-secondary hover:text-text-primary',
      },
      size: {
        // Toggle has no `iconOnly` prop, so squareness rides on the padding:
        // `px = (height − 16px icon) / 2` lands a lone 16px icon on Button's
        // icon-only box while a toggle with text still auto-widens (as the stable
        // recipe does). `sm`'s 10px rounding sits between `--radius-md` (8px) and
        // `--radius-lg` (12px) — no scale step there, so it stays arbitrary.
        sm: 'h-8 gap-1 rounded-[10px] px-2', // icon-only → 32×32 (Button sm)
        default: 'h-9 gap-1.5 rounded-lg px-2.5', // icon-only → 36×36 (Button md)
        lg: 'h-10 gap-1.5 rounded-lg px-3', // icon-only → 40×40 (Button lg)
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
